module.exports = __webpack_public_path__ + "static/broccoli@2x-d9a4e26127c88e631683636c8f1c79c9.png";